exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".owl-carousel .owl-item img{display:block;width:auto}", ""]);

// exports
